import createCache from '@emotion/cache';

const customEmotionCache = createCache({
  key: 'mui', // default is 'css', you can change it
  prepend: true,
});

export default customEmotionCache;